import { api } from '@/lib/api-client';
import type { PublicUser } from './types';

export async function meApi(): Promise<PublicUser> {
  const { data } = await api.get<{ user: PublicUser }>('/auth/me');
  return data.user;
}

export async function logoutApi(): Promise<void> {
  await api.post('/auth/logout');
}
